import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Metrics } from 'framework-listing-lib/internal/metrics';
const EVENT_KEY = 'LISTING_LIB';
const CLOSE_DEV_TOOLS = 'CLOSE_DEV_TOOLS';
const OPEN_DEV_TOOLS = 'OPEN_DEV_TOOLS';
export default function useOpenDevTools() {
  "use memo";

  const $ = _c(4);
  const [openState, setOpenState] = useState(false);
  const setOpen = _temp;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handler = event => {
        if (!event || !event.data) {
          return;
        }
        const {
          key,
          action
        } = event.data;
        if (key !== EVENT_KEY) {
          return;
        }
        bb18: switch (action) {
          default:
            {
              break bb18;
            }
          case CLOSE_DEV_TOOLS:
            {
              setOpenState(false);
              Metrics.counter("close-dev-tools").increment();
              break bb18;
            }
          case OPEN_DEV_TOOLS:
            {
              setOpenState(true);
              Metrics.counter("open-dev-tools").increment();
            }
        }
      };
      window.addEventListener("message", handler);
      return () => window.removeEventListener("message", handler);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== openState) {
    t2 = [openState, setOpen];
    $[2] = openState;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(open) {
  window.postMessage({
    key: EVENT_KEY,
    action: open ? OPEN_DEV_TOOLS : CLOSE_DEV_TOOLS
  });
}